export default __webpack_public_path__ + "static/media/rack-cabo.4524b0c5.png";